const baseUrl = '/admin';
export const adminApiRoutes = {
  baseUrl: "".concat(baseUrl),
  companies: "".concat(baseUrl, "/company"),
  company: id => "".concat(baseUrl, "/company/").concat(id),
  createAccount: "".concat(baseUrl, "/account"),
  loginImpersonate: _ref => {
    let companyId = _ref.companyId;
    return "".concat(baseUrl, "/account/impersonate/").concat(companyId);
  },
  adminAccounts: "".concat(baseUrl, "/account/admins"),
  updateAdmin: accountId => "".concat(baseUrl, "/account/admins/").concat(accountId),
  deleteAdmin: _ref2 => {
    let accountId = _ref2.accountId;
    return "".concat(baseUrl, "/account/admins/").concat(accountId);
  },
  blockAdmin: accountId => "".concat(baseUrl, "/account/admins/").concat(accountId, "/block"),
  unblockAdmin: accountId => "".concat(baseUrl, "/account/admins/").concat(accountId, "/unblock"),
  utilityCredentials: '/utilityPortalCredentials',
  disableUtilityCredential: credentialId => "/utilityPortalCredentials/".concat(credentialId, "/disable"),
  resumeUtilityCredential: credentialId => "/utilityPortalCredentials/".concat(credentialId, "/resume"),
  utilityCredentialEntitlement: '/utilityPortalCredentials/entitlement',
  billScrapingHealth: '/billscraping/health',
  billScrapingCoverage: '/billscraping/coverage',
  billScrapingProviders: '/billscraping/providers',
  billScrapingScoreboard: '/billscraping/scoreboard',
  billQueue: '/billqueue',
  billQueueCycles: '/billqueue/cycles',
  billQueueItem: allocationTableId => "/billqueue/".concat(allocationTableId),
  billQueueChanges: '/billqueue/changes',
  billQueueChangesSeen: '/billqueue/changes/seen',
  billQueueClaim: allocationTableId => "/billqueue/".concat(allocationTableId, "/claim"),
  billQueueRelease: allocationTableId => "/billqueue/".concat(allocationTableId, "/release"),
  billQueueState: allocationTableId => "/billqueue/".concat(allocationTableId, "/state"),
  billQueueBill: allocationTableId => "/billqueue/".concat(allocationTableId, "/bill"),
  billQueueReveal: credentialId => "/billqueue/credentials/".concat(credentialId, "/reveal")
};